import { render, staticRenderFns } from "./ApprovalInfoItem.vue?vue&type=template&id=19cfe06c&scoped=true&"
import script from "./ApprovalInfoItem.vue?vue&type=script&lang=js&"
export * from "./ApprovalInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalInfoItem.vue?vue&type=style&index=0&id=19cfe06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cfe06c",
  null
  
)

export default component.exports